import { render, staticRenderFns } from "./radar.vue?vue&type=template&id=22784d90&"
import script from "./radar.vue?vue&type=script&lang=js&"
export * from "./radar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports